class APIS {
	apis() {
		return {
			color_shortcuts_configs: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/users/layout/create'
			},
			get_color_shortcuts_configs: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/user/layout'
			},
			get_products: {
				headers: {
					'xt-user-token':
						'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRUb2tlbklkIjoiYWQ5NmRjMWYtYmUzMC00MjQ5LWJkNTAtZWZhODg2ODJkYzk5IiwiY2xpZW50VXVpZCI6IjkxNjJkNjIwLTQ1NWUtNDAwNi04ZTM5LWNhNmZhZTEyYzA0MCIsImNsaWVudCI6IjAiLCJhY3RvciI6IjEzIiwidXNlclRva2VuSWQiOiIwNjVjM2Y0MS01OTE1LTRlY2ItYWYxNC1mMDY1ZDgwNWEyNjAiLCJ0aW1lIjoxNjY5MTU4MjQ2MTI1LCJtYXhfdG9rZW5fY291bnQiOi0xLCJpYXQiOjE2NjkxNTgyNDZ9.T5ZpS3LG652M5MKt5zClUnlDEVmmcG7IY-TkXvuCQKw'
				},
				method: 'post',
				path: '/client/products'
			},
			update_color_shortcuts_configs: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/users/layout/update'
			}
		};
	}
}

export default new APIS();
